export enum UserTrackingFunction {
  ADMINISTRATOR,
  SUPERVISOR,
  AGENT,
}
